
import { Box } from '@mui/material';
import React from 'react';
import OnboardingForm from '../../component/Layout/OnBoardingProduct/OnboardingForm';

const ProductOnBoarding = () => {
  return (
    <Box sx={{ padding: 0, backgroundColor: "white" }}>
      <OnboardingForm/>
    </Box>
  );
};

export default ProductOnBoarding;
